const STORAGE_KEY = 'bliss_stale_deploy_reload_at'
let reloadRequested = false

/** One hard reload after deploy chunk/CSS mismatch; avoid infinite flicker loops. */
export function reloadOnceForStaleDeploy(reason: string): boolean {
  if (typeof window === 'undefined') return false

  if (reloadRequested) return false
  const now = Date.now()
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    const last = raw ? Number(raw) : 0
    if (last && now - last < 15_000) return false
    sessionStorage.setItem(STORAGE_KEY, String(now))
  } catch {
    // Without persistent loop protection, leave recovery to the explicit retry.
    return false
  }
  reloadRequested = true
  console.warn('[deploy] Stale asset detected — reloading once:', reason)
  window.location.reload()
  return true
}

export function isStaleDeployErrorMessage(msg: string): boolean {
  const m = msg.toLowerCase()
  return (
    m.includes('failed to fetch dynamically imported module') ||
    m.includes('importing a module script failed') ||
    m.includes('unable to preload css') ||
    m.includes('error loading dynamically imported module') ||
    m.includes('loading chunk') && m.includes('failed')
  )
}

